import type { TargetTemplateInfo } from './types';

export type SelectionMap = Map<string, Set<string>>;
export type ConflictMap = Map<string, 'overwrite' | 'keep'>;
export type FuelChip = 'ALL' | string;

export const conflictKey = (templateKey: string, configKey: string) =>
  `${templateKey}::${configKey}`;

export function totalChanges(sel: SelectionMap, conflicts: ConflictMap): number {
  let n = 0;
  for (const [tKey, cfgs] of sel) {
    for (const cKey of cfgs) {
      if (conflicts.get(conflictKey(tKey, cKey)) === 'keep') continue;
      n += 1;
    }
  }
  return n;
}

export function visibleHiddenSplit(
  sel: SelectionMap,
  targets: TargetTemplateInfo[],
  filter: FuelChip,
): { visible: number; hidden: number } {
  let visible = 0;
  let hidden = 0;
  for (const [tKey] of sel) {
    const t = targets.find(x => x.templateKey === tKey);
    if (!t) continue;
    const fuel = t.fuelType.toUpperCase() || 'NONE';
    if (filter === 'ALL' || fuel === filter) visible += 1;
    else hidden += 1;
  }
  return { visible, hidden };
}

export function targetMatchesFilter(t: TargetTemplateInfo, filter: FuelChip): boolean {
  if (filter === 'ALL') return true;
  const fuel = t.fuelType.toUpperCase() || 'NONE';
  return fuel === filter;
}
